import { useEffect, useState, useContext, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Alert, Autocomplete, AutocompleteRenderInputParams, CircularProgress, Grid, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { DataProductoIngresado } from '../../interfaces/DataBsqProy';
import { HiPencil, HiDocumentSearch } from 'react-icons/hi';
import { GrDocumentPdf } from 'react-icons/gr'
import { IoDocumentAttachSharp } from "react-icons/io5";
import { Button } from '@mui/material';
import CatalogService from '../../services/CatalogService';
import { TipoProductoDTO } from '../../interfaces/TipoProductoDTO';
import { Modal as ModalStrap, ModalHeader, ModalFooter, ModalBody, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO, setProductoTerminadoDTO } from '../../interfaces/ProductoTerminadoDTO';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import ProductoService from '../../services/ProductoService';
import { TblProductoProdTermin, setProductoTerminado } from '../../interfaces/TblProductoProdTermin';
import { TblDecInvMotivoProdTermin, getVoidMotivo, setProductoMotivo } from '../../interfaces/TblDecInvMotivoProdTermin';
import { ProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from '../../interfaces/ProductoAreaConocimientoDTO';
import { ProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from '../../interfaces/ProductoLineaInvestigacionDTO';
import { ProductoColaboradorDTO, setListProductoColaborador } from '../../interfaces/ColaboradorProdcutoDTO';
import { ProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from '../../interfaces/ProductoTerminadoObjOdDTO';
import { format } from 'date-fns';
import { ObjetoLabelFilter } from '../../interfaces/ObjetoLabel';
import AlertService from '../../services/AlertService';
import BotonArchivoAdjunto from './BottonAdjuntos';
import { ProductoTerminSolicitanteDTO, setListProductoTerminSolicitante } from '../../interfaces/ProductoTerminSolicitanteDTO';
import { ProductoObjEspecifico, setListProductoEspecifico } from '../../interfaces/ProductoObjEspecificoDTO';
import { setListProyectoRelacionado } from '../../interfaces/ProyectoRelacionado';
import { setProductoInstitucionPais } from '../../interfaces/ProductoInstitucionPaisDTO';
import { ProductoArchivo, setListProductoArchivo } from '../../interfaces/ProductoArchivo';
import { setProductoPostGrado } from '../../interfaces/ProductoPostGradoDTO';
import { setListProductoResultado } from '../../interfaces/ProductoResultadoDTO';
import { ProductoFactorImpacto, SetListProductoFactorImpacto } from '../../interfaces/ProductoFactorImpacto';
import { ProductoAreaImplementacion, setAreaImplementacion } from '../../interfaces/ProductoAreaImplementacionDTO';
import { AiFillDelete } from 'react-icons/ai';
import { FaWindowClose } from 'react-icons/fa';
import { DetalleProducto } from './DetalleProducto';
import { ProyectoParticipoDTO } from '../../interfaces/ProyectosDTOS/ProyectoParticipoDTO';
import ProyectoService from '../../services/ProyectoService';
import { TablaProductoIngresadoDTO } from '../../interfaces/TablaProductoIngresadoDTO';

interface Column {
  id: 'proy' | 'title' | 'type' | 'year' | 'creator' | 'colaborador' | 'opcions';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'proy', label: 'Proyecto', minWidth: 120 },
  { id: 'title', label: 'Titulo', minWidth: 120 },
  {
    id: 'type',
    label: 'Tipo',
    minWidth: 85,
  },
  {
    id: 'year',
    label: 'Año',
    minWidth: 85,
  },
  {
    id: 'colaborador',
    label: 'Colaborador del producto',
    minWidth: 80,
  },
  {
    id: 'opcions',
    label: 'Opciones',
    minWidth: 100,
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const catalogService = new CatalogService;
const productoService = new ProductoService();
const alertService = new AlertService();
const proyectoService = new ProyectoService();
export default function TableProductosParticipoProyecto(props: DataProductoIngresado) {
  let history = useNavigate()
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const idpersona = casUserContext.userData.idpersona;
  const token = casUserContext.token;
  const user = casUserContext.userData;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
  const [tipoProductos, setTipoProductos] = useState<Array<TipoProductoDTO>>([]);
  const [listRolColaborador, setListRolColaborador] = useState<Array<ObjetoLabelFilter>>([])
  const [modal, setModal] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [ready, setReady] = useState(false);
  const [datos, setDatos] = useState<ProductoTerminadoDTO>(() => getVoidProdcutoTerminadoDTO());
  const [selectedProyecto, setSelectedProyecto] = useState<ProyectoParticipoDTO | null>(null);
  const [productos, setProductos] = useState<Array<TablaProductoIngresadoDTO>>([]);
  const [ids,setIds] = useState<Array<number>>([]);
  async function llamarProducto(idProducto: number) {
    toggleModal();
    setReady(false);
    await productoService.GetProductoTerminadoById(idProducto, token)
      .then((data) => {
        setProducto(data)
        //console.log(data)
      })
      .catch((error) => console.error(error));
  }
  async function llamarProductoEliminar(idProducto: number) {
    toggleModalEliminar();
    setReady(false);
    await productoService.GetProductoTerminadoById(idProducto, token)
      .then((data) => {
        setProducto(data)
      })
      .catch((error) => console.error(error));
  }
  async function filtroPorProyecto(idProyecto: number | undefined) {
    //console.log(idProyecto)
    if(idProyecto === undefined){
      setProductos(props.data)
    }else{
      setProductos(props.data.filter(x => 
        x.producto.iddecinvproyecto === idProyecto
      ))
    }
  }
  async function eliminarProducto(idProducto: number) {
    alertService.showLoading("Espere...");
    await productoService.SoftDeleteProductoById(idProducto, token)
      .then((data) => {
        if (data.status.isSuccessfully) {
          alertService.hideLoading();
          alertService.alertaExito("Exito", "El producto fue eliminado y la pagina se recargara.")
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          alertService.hideLoading();
          alertService.alertaAdvertenciaList("Alerta", data.status.messages)
        }

      })
      .catch((error) => {
        console.error(error)
      });
  }
  const setIdcategoria = (data: any) => {
    return data as number
  }
  function setProducto(data: any) {
    //console.log(data.data);
    setDatos({
      ...datos,
      producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
      motivo: setProductoMotivo(data.data.motivo ?? getVoidMotivo()) as TblDecInvMotivoProdTermin,
      areaConocimiento: setProductoAreaConocimientoDTO(data.data.areaConocimiento) as ProductoAreaConocimientoDTO,
      areaImplementacion: setAreaImplementacion(data.data.areaImplementacion) as ProductoAreaImplementacion,
      lineaInvestigacion: setProductoLineaInvestigacionDTO(data.data.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
      ods: setProductoTerminadoObjOdDTO(data.data.ods) as ProductoTerminadoObjOdDTO,
      colProducto: setListProductoColaborador(data.data.colProducto) as Array<ProductoColaboradorDTO>,
      solicitantes: setListProductoTerminSolicitante(data.data.solicitantes) as Array<ProductoTerminSolicitanteDTO>,
      institucion: setProductoInstitucionPais(data.data.institucion),
      archivosProd: setListProductoArchivo(data.data.archivosProd),
      proyectorel: setListProyectoRelacionado(data.data.proyectorel),
      postgrados: setProductoPostGrado(data.data.postgrados),
      objEspecificos: setListProductoEspecifico(data.data.objEspecificos) as Array<ProductoObjEspecifico>,
      factorImpacto: SetListProductoFactorImpacto(data.data.factorImpacto) as Array<ProductoFactorImpacto>,
      resultados: setListProductoResultado(data.data.resultados),
      idCategoriaProducto: setIdcategoria(data.idCategoriaProducto),
      idpersona: idpersona
    });
    setReady(true);
    //console.log(modal);
  }
  const toggleModal = () => {
    setModal(!modal);
  }
  const toggleModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  }
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  const goToNavigation = (site: string) => {
    history(site)
  }
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const fetchData = async () => {
    try {
      catalogService.obtenerAllTipoProducto()
        .then((data) => setTipoProductos(data.listData))
        .catch((error) => console.error(error))
      setListRolColaborador(catalogService.getRolColaboradorProducto)
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const preparar = () => {
    setProductos(props.data);
    const listaDeIdsUnicos: number[] = Array.from(new Set(props.data.map((proyecto) => proyecto.producto.iddecinvproyecto)));
    //console.log(listaDeIdsUnicos)
    setIds(listaDeIdsUnicos);
  };

  useEffect(() => {
    preparar();
    fetchData();
  }, []);

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Card>
        <CardHeader><strong>Productos Terminados ingresados a través de los Proyectos en los que participa el Investigador</strong></CardHeader>
        <CardBody>
          {props.mostrarAlert ?
            <Alert severity="info">
              Estimado Investigador, los productos que aparecen en esta tabla son aquellos que pertenecen a algún proyecto en el que usted participe como colaborador.
            </Alert>
            : <></>}
          <br />
          {props.proyParticipo ?
            <>
              <Autocomplete
                options={props.proyParticipo.filter(x => ids.includes(x.idProyecto))}
                getOptionLabel={(option) => option.titulo}
                onChange={(event, newValue) => {
                  setSelectedProyecto(newValue);
                  filtroPorProyecto(newValue?.idProyecto)
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Filtro por proyecto" variant="outlined" />
                )}
              />
              <br />
            </>
            : <></>}
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      style={{ minWidth: column.minWidth }}
                      key={column.id}
                      align={column.align}>
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              {props.ready ?
                <TableBody>
                  {productos.length > 0 ? productos
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <StyledTableRow key={row.producto.iddecinvproyectoprodtermin}>
                          <StyledTableCell component="th" scope="row">
                            {row.tituloProyecto}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.producto.titulo}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.nombreTipoProducto}
                          </StyledTableCell>
                          <StyledTableCell align="left">{row.producto.anio}</StyledTableCell>
                          <StyledTableCell align="left">{row.colaborador ? 'Si' : 'No'}</StyledTableCell>
                          <StyledTableCell align="left">
                            <Tooltip title={"Ver"} placement="top" arrow >
                              <IconButton aria-label="ver"
                                color='success' onClick={() => { llamarProducto(row.producto.iddecinvproyectoprodtermin) }}>
                                <HiDocumentSearch />
                              </IconButton>
                            </Tooltip>
                            {row.motivo ? row.motivo.idpersona === user.idpersona ?
                              <Tooltip title={"Eliminar"} placement="top" arrow >
                                <IconButton aria-label="eliminar"
                                  color="error" onClick={() => { llamarProductoEliminar(row.producto.iddecinvproyectoprodtermin) }}>
                                  <AiFillDelete />
                                </IconButton>
                              </Tooltip>
                              : <></> : <></>}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }) :
                    <StyledTableRow key={0}>
                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                      <StyledTableCell align="left">No hubo resultados</StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                    </StyledTableRow>
                  }
                </TableBody>
                : <CircularProgress disableShrink />}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={productos.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </CardBody>
      </Card>
      <ModalStrap isOpen={modal} toggle={toggleModal} className="custom-modal">
        <ModalHeader toggle={toggleModal}>
          <Typography id="modal-modal-title" variant="h4"><strong>Detalle Producto</strong></Typography>
        </ModalHeader>
        <ModalBody>
          {ready ?
            <DetalleProducto datos={datos} token={token} listRolColaborador={listRolColaborador} tipoProductos={tipoProductos} />
            :
            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
              <CircularProgress color="success" />
            </Stack>
          }
        </ModalBody>
      </ModalStrap>
      <ModalStrap isOpen={modalEliminar} toggle={toggleModalEliminar} className="custom-modal">
        <ModalHeader toggle={toggleModalEliminar}>
          <Typography id="modal-modal-title" variant="h4"><strong>Eliminar Producto</strong></Typography>
        </ModalHeader>
        <ModalBody>
          {ready ?
            <>
              <Grid container spacing={2}>
                <Grid container spacing={2} sx={{ m: 1 }} alignItems="center" justifyContent="center">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h5">¿Estás seguro de que deseas eliminar este producto? Esta acción no se puede deshacer.</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ m: 1 }} alignItems="center" justifyContent="center">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h5">
                      <strong>{datos.producto.titulo}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
            :
            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
              <CircularProgress color="success" />
            </Stack>
          }
        </ModalBody>
        <ModalFooter>
          <Grid container spacing={2} justifyContent="flex-start">
            <Grid item xs={12} sm={6} md={4}>
              {/* <Button variant="contained" color="success" startIcon={<FaWindowClose />} >Cerrar</Button> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4} >
              <Button variant="contained" color="success" startIcon={<FaWindowClose />} onClick={() => { toggleModalEliminar() }}>Cerrar</Button>
            </Grid>
            <Grid item xs={12} sm={6} md={4} >
              <Button variant="contained" color="error" startIcon={<AiFillDelete />} onClick={() => { eliminarProducto(datos.producto.iddecinvproyectoprodtermin) }}>Eliminar</Button>
            </Grid>
          </Grid>
        </ModalFooter>
      </ModalStrap>
    </Paper>
  );
}

function setTipoProductos(objDatos: any): any {
  throw new Error('Function not implemented.');
}
